import { CircularProgress, Stack, Typography } from "@mui/material";
import { RateIndicator } from "../../../types/enums";
import { RateIndicatorIcon } from "../../ui/RateIndicatorIcon";

type Props = {
  value: number;
  indicator?: RateIndicator;
  indicatorChange?: number;
  indicatorChangeAt?: string;
};

export const EngagementRate = ({
  value,
  indicator,
  indicatorChange,
  indicatorChangeAt,
}: Props) => {
  return (
    <Stack
      sx={{ position: "relative", width: "136px", height: "136px" }}
      justifyContent="center"
    >
      {indicator && (
        <Stack
          sx={{
            position: "absolute",
            left: 60,
            top: indicator === RateIndicator.up ? 30 : 88,
            zIndex: 5,
          }}
        >
          <RateIndicatorIcon
            indicatorRate={indicator}
            indicatorChange={indicatorChange}
            indicatorChangeAt={indicatorChangeAt}
          />
        </Stack>
      )}
      <CircularProgress
        size={136}
        thickness={6}
        variant="determinate"
        sx={{
          color: "#3279B3",
          position: "absolute",
          left: 0,
          top: 0,
          zIndex: 2,
          opacity: 1,
        }}
        value={value}
      />
      <CircularProgress
        size={136}
        thickness={6}
        variant="determinate"
        sx={{
          color: "#F7F7F7",
          position: "absolute",
          left: 0,
          top: 0,
          zIndex: 1,
        }}
        value={100}
      />
      <Typography
        variant="h3"
        align="center"
        sx={{
          flexShrink: 1,
          fontSize: "32px",
          color: "#181818",
        }}
      >
        {value}%
      </Typography>
    </Stack>
  );
};
